export const SET_SECURITY_QUESTIONS = "set_security_questions";
export const ERROR_ACTION = "set_and_display_error";
export const SET_REGISTRATION_RESPONSE = "set_registration_response";
export const SET_USER_SESSION = "set_user_session";
export const LOGOUT_CLEAR_USER_SESSION = "logout_clear_user_session";
export const SET_CAPTCHA_IMAGE = "set_captcha_image";
export const SET_DEPARTMENTS = "set_departments";
export const SET_GET_OTP_RESPONSE = "set_get_otp_response";
export const SET_VERIFY_OTP_FLAG_EMAIL = "set_verify_otp_flag_email";
export const SET_VERIFY_OTP_FLAG_MOBILE = "set_verify_otp_flag_mobile";
export const SET_GET_ACTIVE_USER = "set_get_active_user";
export const SET_GET_APPROVAL_USER = "set_get_approval_user";
export const SET_ROLE_BY_DEPT = "set_role_by_dept";
export const SET_SUPERVISOR_BY_ROLE = "set_supervisor_by_role";
export const SET_VERIFY_USER = "set_verify_user";
export const SET_VERIFY_SHOW = "set_verify_show";
export const SET_EMAIL_OTP_FLAG_VERIFY = "set_email_otp_flag_verify";
export const SET_MOBILE_OTP_FLAG_VERIFY = "set_mobile_otp_flag_verify";
export const SET_OTP_VERIFICATION_EMAIL_STATUS =
  "set_otp_verification_email_status";
export const SET_OTP_VERIFICATION_MOBILE_STATUS =
  "set_otp_verification_mobile_status";
export const SET_BOTH_OTP_VERIFICATION = "set_both_otp_verification_status";
export const SET_RESET_PWD_SHOW = "set_reset_pwd_show";
export const SET_USERNAME = "set_username";
export const SET_USER_NAME_FOR_LOGIN = "set_user_name_for_login";
export const SET_API_REPO_VERSION = "set_api_repo_version";
export const SET_GET_ACTIVE_ADVERTISEMENT = "set_get_active_advertisement";
export const SET_GET_PAST_ADVERTISEMENT = "set_get_past_advertisement";
export const SHOW_LOADER = "show_loader";
export const HIDE_LOADER = "hide_loader";
export const SET_GET_EMAIL_OTP_RESPONSE = "set_get_email_otps_response";
export const SET_GET_MOBILE_OTP_RESPONSE = "set_get_mobile_otps_response";
export const SET_VERIFY_OTP_FLAG_LOGIN = "set_verify_otp_login";
export const SET_VERIFY_OTP_FLAG_FORGOT_PASSWORD =
  "set_verify_otp_forgot_password";
export const SET_VERIFY_OTP_FLAG_REGISTRATION_MOBILE =
  "set_verify_otp_flag_registration_mobile";
export const SET_VERIFY_OTP_FLAG_REGISTRATION_EMAIL =
  "set_verify_otp_flag_registration_email";
export const SET_FORGOT_PASSWORD_STATE = "set_forgot_password_state";
export const SET_CHANGE_PWD_MODAL = "set_change_pwd_modal";
export const SET_ADVERTISEMENT_VIEW = "set_advertisement_view";
export const SET_CHALLAN_DETAILS = "set_challan_details";
export const SET_CANDIDATES_CHALLAN_DETAILS = "set_candidates_challan_details";
export const SET_CANDIDATES_CHALLAN_UPLOAD = "set_candidates_challan_upload";
export const SET_ADVERTISEMENT_DETAILS_AND_CANDIDATE_LIST =
  "set_advertisement_details_and_candidate_list";
export const SET_SHOW_VERIFY_DOCUMENT_TABLE = "set_show_verify_document_table";
export const SET_SHOW_APPROVE_DOC_MODAL = "set_show_approve_doc_modal";
export const SET_SHOW_REJECT_DOC_MODAL = "set_show_reject_doc_modal";
export const SET_DOCUMENTLIST_BY_CANDIDATE = "set_documentlist_by_candidate";
export const SET_CANDIDATES_BY_ADVERTISEMENT =
  "set_candidates_by_advertisement";
export const SET_VIEW_DOC_MODAL = "set_view_doc_modal";
export const SET_USER_BY_ADVERTISEMENT = "set_user_by_advertisement";
export const SET_PROFILE_INFO_BY_CANDIDATE = "set_profile_info_by_candidate";
export const SET_APPROVAL_DOC_LIST = "set_approval_doc_list";
export const SET_CANCEL_REJECT_APPLICATIONS_LIST =
  "set_cancel_reject_applications_list";
export const SET_CANCEL_REJECT_APPLICATIONDATA_BY_ADVERTISEMENT =
  "SET_CANCEL_REJECT_APPLICATIONDATA_BY_ADVERTISEMENT";
export const SET_ADVERTISEMENT_DETAILS = "set_advertisement_details";
export const SET_APPROVAL_ACTION_HISTORY = "set_approval_action_history";
export const SET_SHOW_ACTIVE_TAB_CANDIDATE_DETAILS =
  "set_show_active_tab_candidate_details";
export const ADVERTISEMENT_LIST_FOR_DOCUMENT_APPROVAL =
  "advertisement_list_for_document_approval";
export const SET_ADVERTISEMENT_DETAILS_AND_DOC_APPROVAL_LIST =
  "set_advertisement_details_and_doc_approval_list";
export const CANDIDATE_LIST_FOR_CHECK_ELIGIBILTY =
  "candidate_list_for_check_eligibilty";
export const ACTIVE_ADVERTISEMENT_LIST = "active_advertisement_list";
export const SET_ADVERTISEMENT_DETAILS_FOR_CANDIDATE =
  "set_advertisement_details_for_candidate";
export const SET_APPLICATION_ELIGIBILITY_INFO =
  "set_application_eligibility_info";
export const SET_PROFILE_INFO_DISPLAY = "set_profile_info_display";
export const SET_PROFILE_CREATION_LOOKUPS = "set_profile_creation_lookups";
export const SET_QUALIFICATION_TYPES = "set_qualification_types";
export const SET_APPLICATION_RE_CHECK_ELIGIBILITY_INFO =
  "set_application_re_check_eligibility_info";
export const SET_APPLICATION_POST_PREF_LIST_RE_CHECK_ELIGIBILITY =
  "set_application_post_pref_list_re_check_eligibility";
export const SET_ELIGIBILITY_BUTTON_DISABLE = "set_eligibility_button_disable";
export const SET_UNIVERSITIES = "set_universities";
export const SET_UNIVERSITIES_PAGE_NO_COUNTER =
  "set_universities_page_no_counter";
export const SET_UNIVERSITY = "set_university";
export const SET_UNIVERSITY_STATES = "set_university_states";
export const SET_MODULES_LIST = "set_modules_list";
export const SET_TYPES_LIST = "set_types_list";
export const SET_PARENT_LABELS_LIST = "set_parent_labels_list";
export const SET_LOOKUP_OPTIONS = "set_lookup_options";
export const SET_LOOKUP_OPTIONS_PAGE_NO_COUNTER =
  "set_lookup_options_page_no_counter";
export const SET_LOOKUP_OPTION = "set_lookup_option";
export const SET_PARENT_LOOKUP_DATA = "set_parent_lookup_data";
export const SET_PARENT_TYPE_LIST = "set_parent_type_list";
export const SET_STATE = "set_state";
export const SET_ALL_STATES = "set_all_states";
export const SET_ALL_STATES_PAGE_NO_COUNTER = "set_all_states_page_no_counter";
export const SET_ALL_DISTRICT_STATES = "set_all_district_states";
export const SET_ALL_DISTRICT = "set_all_district";
export const SET_DISTRICT = "set_district";
export const SET_ALL_DISTRICT_PAGE_NO_COUNTER =
  "set_all_district_page_no_counter";
export const SET_ALL_TALUKA_STATES = "set_all_taluka_states";
export const SET_ALL_TALUKA_DISTRICTS = "set_all_taluka_districts";
export const SET_ALL_TALUKA = "set_all_taluka";
export const SET_TALUKA = "set_taluka";
export const SET_ALL_TALUKA_PAGE_NO_COUNTER = "set_all_taluka_page_no_counter";
export const SET_ALL_VILLAGE_STATES = "set_all_village_states";
export const SET_ALL_VILLAGE_DISTRICTS = "set_all_village_districts";
export const SET_ALL_VILLAGE_TALUKAS = "set_all_village_talukas";
export const SET_ALL_VILLAGE = "set_all_village";
export const SET_VILLAGE = "set_village";
export const SET_ALL_VILLAGE_PAGE_NO_COUNTER =
  "set_all_village_page_no_counter";
export const SET_UPLOAD_MARKSHEET_LIST = "set_upload_marksheet_list";
export const SET_APPLICATION_STAGES_VIEW = "set_application_stages_view";
export const SET_ALL_STAGES_LIST = "set_advertisement_stages_list";
export const SET_ADVT_DETAILS = "set_advertisement_details";
export const SET_ADVT_POSTS_DATA = "set_advertisement_retotaling_data";
export const SET_STAGE = "set_stage";
export const SET_ALL_STAGES = "set_all_stages";
export const SET_ALL_STAGES_PAGE_NO_COUNTER = "set_all_stage_page_no_counter";
export const SET_ALL_STAGES_CONFIG_LIST = "set_all_stages_config_list";
export const SET_ALL_SUBJECTS_LIST = "set_all_subjects_list";
export const SET_ALL_VENUE_LIST = "set_all_venue_list";
export const SET_ALL_EXAM_CENTERS_LIST = "set_all_exam_centers_list";
export const SET_ALL_STATES_LIST = "set_all_states_list";
export const SET_ALL_DISTRICTS_LIST = "set_all_districts_list";
export const SET_ALL_SUBDISTRICTS_LIST = "set_all_subdistricts_list";
export const SET_ALL_VILLAGES_LIST = "set_all_villages_list";
export const SET_ALL_COORDINATOR_ROLES_LIST = "set_all_Coordinator_roles_list";
export const SET_ALL_EXAM_MODES_LIST = "set_all_exam_modes_list";
export const SET_ALL_COORDINATOR_GENDERS_LIST =
  "set_all_Coordinator_genders_list";
export const SET_ALL_UNAPPROVAL_ENTITY_LIST = "set_all_unapproval_entity_list";
export const SET_UNAPPROVAL_DUPLICATE_ROLL_NO_LIST = "set_unapproval_duplicate_roll_no_list";
export const SET_UNAPPROVAL_OUT_OF_RANGE_LIST = "set_unapproval_out_of_range_list";
export const SET_UNAPPROVAL_ABSENTEE_LIST = "set_unapproval_absentee_list";
export const SET_ALL_APPROVED_ENTITY_LIST = "set_all_approved_entity_list";
export const SET_UPLOAD_CSV = "set_upload_csv";
export const SET_ALL_ADMINISTRATIVE_DEPARTMENT_DROPDOWN =
  "set_all_administrative_department";
export const SET_DEPARTMENT_NAMES_COMBO = "set_department_names_combo";
export const SET_EXAM_TYPES_COMBO = "set_exam_types_combo";
export const SET_POST_NAMES_COMBO = "set_post_names_combo";
export const SET_GROUP_NAMES_COMBO = "set_group_names_combo";
export const SET_ALL_ADVERTISEMENTREPORT = "set_all_adevertisement_report";
export const SET_ALL_ADVERTISEMENTREPORT_PAGE_NO_COUNTER =
  "set_all_advertisement_report_page_no_counter";
export const SET_RECRUITMENT_TYPES_COMBO = "set_recruitment_types_combo";
export const SET_ALL_DEPARTMENTWISESUMMARY =
  "set_all_departmentwise_summary_report";
export const SET_ALL_DEPARTMENTWISESUMMARY_PAGE_NO_COUNTER =
  "set_all_departmentwise_summary_report_page_no_counter";
export const SET_All_ADVERTISEMENT_REPORT_DATA =
  "set_advertisement_report_list";
export const SET_All_DEPARTMENTWISE_REPORT_DATA =
  "set_departmentwise_summary_report_list";
export const SET_All_REQUISITION_REPORT_DATA =
  "set_requisition_data_report_list";
export const GET_OTP_TIMER = "get_otp_timer";
export const GET_OTP_TIMER_MOBILE = "get_otp_timer_mobile";
export const GET_OTP_TIMER_EMAIL = "get_otp_timer_email";
export const SET_APPLICATION_DETAILS = "set_application_details";
export const SET_PROFILE_DETAILS = "set_profile_details";
export const SET_ALL_ADVERTISEMENTS = "set_all_advertisements";
export const GET_ALL_ROLES = "get_all_roles";
export const SET_ALL_UPLOADED_DOCUMENTS = "set_all_uploaded_documents";
export const SET_ALL_EXAMS = "set_all_exams";
export const SET_EXAMS = "set_exams";
export const SET_YEAR_BY_ID = "set_advertisement_by_id"
export const SET_YEAR = "set-year";
export const SET_ANSWERKEY_UPLOAD = "set_answerkey_upload";
export const SET_SUBJECTS = "set_subjects";
export const SET_SUPERVISORS = "set_supervisors";
export const SET_SUPERVISORS_BY_ID = "set_supervisors_by_id";
export const SET_ALL_REPORT_COUNTS = "set_all_report_counts";
export const SET_MASTER_TYPES = "set_master_types";
export const SET_TRANSACTIONAL_DATA_TYPES = "set_transactional_data_types";
export const SET_ALL_TYPES = "set_all_types";
export const SET_ALL_USER_ROLES = "set_all_user_roles";
export const SET_ALL_USERS_BY_ROLE_ID_FROM = "set_all_users_by_role_id_from";
export const SET_ALL_USERS_BY_ROLE_ID_TO = "set_all_users_by_role_id_to";
export const SET_ALL_MODULES = "set_all_modules";
export const SET_ALL_SUB_MODULES_BY_MODULE_ID =
  "set_all_sub_modules_by_module_id";
export const GET_ALL_ANSWER_KEY_DATA = "get_all_answer_key_data";
export const ANSWER_KEY_DATA_UPDATED_SUCCESS =
  "answer_key_data_updated_success";
export const SET_UNAPPROVAL_PAGE_NO_COUNTER = "set_unapproval_page_no_counter";
export const SET_UNAPPROVAL_DUPLICATE_COUNTER = "set_unapproval_duplicate_counter";
export const SET_UNAPPROVAL_OUT_OF_RANGE_COUNTER = "set_unapproval_out_of_range_counter";
export const SET_UNAPPROVAL_ABSENTEE_LIST_COUNTER = "set_unapproval_absentee_list_counter";
export const ANSWER_KEY_DATA_FOR_APPROVAL = "answer_key_data_for_approval";
export const SET_ASSIGN_SUBMODULES_BY_USER_MODULE_ID =
  "set_assign_submodules_by_user_module_id";
export const SET_ALL_ANSWER_KEYDATA = "set_all_answer_keydata";
export const SET_ALL_QUESTION_SETS = "set_all_question_sets";
export const SET_ALL_UNAPPROVAL_RULES_LIST = "set_all_unapproval_rules_list";
export const SET_UNAPPROVAL_RULE_PAGE_NO_COUNTER =
  "set_unapproval_rule_page_no_counter";
export const ANSWER_RULE_DATA_FOR_APPROVAL = "answer_rule_data_for_approval";
export const SET_ALL_ROLL_NUMBER_LIST = "set_all_roll_number_list";
export const SET_RULES_CALCULATE_RESULT_DATA =
  "set_rules_calculate_result_data";
export const SET_OBJECTIVE_STATUS_DATA =
  "set_objective_status_data";
export const GET_ABSENTEE_LIST = "get_absentee_list";
export const SET_DUPLICATES_LIST = "set_duplicates_list";
export const SET_OUT_OF_RANGE_LIST = "set_out_of_range_list";
export const SET_ABSENTEE_LIST = "set_absentee_list";
// export const SET_ABSENTEE_LIST = "set_absentee_list";
export const SET_ALL_CATEGORIES_LIST = "set_all_categories_list";
export const SET_ALL_SUBCATEGORIES_LIST = "set_all_subcategories_list";
export const SET_ALL_UNAPPROVED_CUTOFF_LIST = "set_all_unapproved_cutoff_list";
export const SET_UNAPPROVAL_CUTOFF_PAGE_NO_COUNTER = "set_unapproval_cutoff_page_no_counter";
export const SET_EXAMINERS_MODERATOR_REPORT_DATA = "get_examiners_moderator_report_data";
export const SET_DIFFERENTIAL_REPORT_DATA = "get_differential_report_data";
export const SET_EXAMINERS_AND_MODERATOR_APPROVAL_LIST = "set_examiners_and_moderator_approval_list";
export const SET_EXAMINERS_AND_MODERATOR_APPROVAL_PAGE_NO_COUNTER = "set_examiners_and_moderator_approval_page_no_counter";
export const SET_ALL_INTERVIEW_ATTENDEE_LIST = "set_all_interview_attendee_list";
export const SET_ALL_INTERVIEW_ABSENTEE_LIST = "set_all_interview_absentee_list";
export const SET_RESERVATION_DATA = "set_reservation_data";
export const SET_SLAB_REPORT_DATA = "set_slab_report_data";
export const SET_INTERVIEW_QUALIFIED_CANDIDATE_DATA = "set_interview_qualified_candidate_data";
export const SET_VENUE_LIST = "set_venue_list";
export const GET_CUT_OFF_LIST = "get_cut_off_list";
export const SET_QUALIFYING_CANDIDATES_LIST = "set_all_qualifying_candidates_list";
export const SET_MARKS_PDF = "set_marks_for_pdf";
export const GET_INTERVIEW_LIST = "get_interview_list";
export const SET_INTERVIEW_MARKS_LIST = "set_interview_marks_list";
export const SET_FILE_OBJECT = "set_file_object";
export const SET_INTERVIEW_MARKS_LIST_PAGE_NO_COUNTER = "set_interview_marks_list_page_no_counter";
export const SET_ALL_UNAPPROVED_INTERVIEWMARKS_LIST = "set_unapproval_interviewmarks_list";
export const SET_UNAPPROVAL_INTERVIEWMARKS_PAGE_NO_COUNTER = "set_unapproval_interviewmarks_page_no_counter";
export const INTERVIEW_MARKS_DATA_FOR_APPROVAL = "set_interview_marks_data_for_approval";
export const SET_VERSION_MISMATCH_LIST = "set_version_mismatch_list";
export const SET_INVIGILATOR_VERSION_MISMATCH_LIST = "set_invigilator_version_mismatch_list";
export const SET_UNAPPROVAL_VERSION_MISMATCH_PAGE_NO_COUNTER = "set_unapproval_version_mismatch_page_no_counter";
export const SET_UNAPPROVAL_VERSION_MISMATCH_LIST = "set_unapproval_version_mismatch_list";
export const GET_INTERVIEW_MARKS_STATEMENT = "get_interview_marks_statement";
export const GET_STATISTICAL_REPORT = "get_statistical_report";
export const SET_MARK_CRITERIA_APPROVAL_LIST = "set_mark_criteria_approval_list";
export const SET_MARK_CRITERIA_APPROVAL_PAGE_NO_COUNTER = "set_mark_criteria_approval_page_no_counter";
export const GET_ALL_TOTAL_OF_STUDNETS = "get_all_total_of_students";
export const GET_MARK_DIFFERENCE_COUNT = "get_mark_difference_count";
export const SET_CHIEF_MODERATOR_MARK_CRITERIA_APPROVAL_LIST = "set_chief_moderator_mark_criteria_approval_list";
export const SET_CHIEF_MODERATOR_MARK_CRITERIA_APPROVAL_PAGE_NO_COUNTER = "set_chief_moderator_mark_criteria_approval_page_no_counter";
export const GET_MODERATOR_MARK_COUNT = "get_moderator_mark_count";
export const SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_LIST = "set_chief_moderator_criteria_approval_list";
export const SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_PAGE_NO_COUNTER = "set_chief_moderator_criteria_approval_page_no_counter";
export const GET_MODERATOR_CANDIDATE_LIST = "get_moderator_candidate_list";
export const GET_CHIEF_MODERATOR_CANDIDATE_LIST = "get_chief_moderator_candidate_list";
export const SET_MODERATOR_CRITERIA_APPROVAL_LIST = "set_moderator_criteria_approval_list";
export const SET_MODERATOR_CRITERIA_APPROVAL_PAGE_NO_COUNTER = "set_moderator_criteria_approval_page_no_counter";
export const GET_PERCENTAGE_COUNT = "get_percentage_count";
export const SET_PRESENT_ABSENT_COUNTS = "set_present_absent_counts";
export const GET_ADD_DEPARTMENT_LIST = "get_add_department_list";
export const SET_DEPARTMENT_TABLE_COUNTER = "set_department_table_counter";
export const GET_STATISTICALDATA = "get_statistical_data";
export const SET_POST_CRITERIA = "set_post_criteria";
export const GET_POSTCRITERIA = "get_postcriteria";
export const SET_CRITERIA_CHECKING_LIST = "get_criteria_checking_list";
export const GET_USER_LISTING = "get_user_listing";
export const SET_UNAPPROVED_USER_LIST = "set_unapproved_user_listing";
export const GET_USER_LISTING_COUNTER = "get_user_list_counter";
export const GET_DUPLICATES_BY_IDS = "get_duplicate_by_ids"
export const GET_ADD_ROLE_LIST = "get_add_role_list";
export const SET_ROLE_TABLE_COUNTER = "set_role_table_counter";
export const GET_APPLICATION_LIST = "get_application_list";
export const GET_PRE_EXAM_ADVER = "get_pre_exam_adver";
export const GET_MAIN_EXAM_ADVER = "get_main_exam_adver"
export const GET_ALL_APPLICATION_POST_PREF_LIST = "get_all_application_post_pref_list";
export const GET_USER_BY_SUPERVISIOR = "get_user_by_supervisior";
export const GET_POST_CRITERIA = "get_post_criteria_statistics";
export const GET_ALL_RETOTALING_LIST = "get_all_retotaling_list";
export const GET_ALL_VIEW_MARKS = "get_all_view_marks";
export const SET_ALPHABETICAL_LIST = "set_alphabetical_list";
export const GET_QUALIFIED_CANDIDATE = "get_qualified_candidate";
export const SET_MODERATOR_MARK_CRITERIA_STATUS = "set_moderator_mark_criteria_status";
export const SET_CHIEF_MODERATOR_MARK_CRITERIA_STATUS = "set_chief_moderator_mark_criteria_status";
export const SET_ROLLNO_QUALIFIED_CANDIDATE = "set_rollno_qualified_candidate"
export const SET_CUTOFF_CRITERIA = "set_cutoff_criteria";
export const SET_RESERVED_SEATS_DATA = "set_reserved_seats_data";
export const SET_PHYSICAL_TEST_DATA = "set_physical_test_data";
export const SET_MEDICAL_TEST_DATA = "set_medical_test_data";
export const SET_PENDING_ACTIVITIES = "set_pending_activaties";
export const SET_CURRENT_ACTIVITIES = "set_current_activaties";
export const SET_ALL_ACTIVITIES = "set_all_activities";
export const SET_ELIGIBLE_RECOMMANDATION_REPORT_DATA = "set_eligible_recommandation_report_data";
export const SET_MERITLIST_REPORT_DATA = "set_merit_list_report_data";
export const SET_INTERVIEW_LIST = "set_interview_list"
export const GET_FLAG_ACCESS_STATUS = "get_flag_access_status";
export const SET_INTERVIEW_POST_PREFERENCE_LIST = "set_interview_post_preference_list";
export const GET_ALL_ALLOTMENT_CHART_DATA = "get_all_allotment_chart_data";
export const SET_RECOMMENDATION_REPORTS = "set_recommendation_reports";
export const SET_BARCODE_AND_ROLLNO = "set_barcode_and_rollno";
export const SET_ALL_DUPLICATE_CODE_DATA = "set_all_duplicate_code_data";
export const GET_QUALIFICATIONTYPE = "get_qualification_type";
export const GET_QUALIFICATION_NAME_BYTYPE = "get_qualification_name_bytype";
export const GET_DESIGNATION = "get_designation";
export const GET_JOB_NATURE = "get_job_nature";
export const GET_APPOINTMENT_NATURE = "get_appointment_nature"
export const SET_ALL_UNAPPROVED_INTERVIEW_CRITERIA_LIST = "set_all_unapproved_interview_criteria_list";
export const SET_UNAPPROVAL_INTERVIEW_CRITERIA_PAGE_NO_COUNTER = "set_unapproval_interview_criteria_page_no_counter";
export const SET_ALL_UNAPPROVED_RECOMMENDATION_CRITERIA_LIST = "set_all_unapproved_recommendation_criteria_list";
export const SET_UNAPPROVAL_RECOMMENDATION_CRITERIA_PAGE_NO_COUNTER = "set_unapproval_recommendation_criteria_page_no_counter";
export const SET_MODERATOR_MODERATION = "set_moderator_moderation";
export const SET_CHIEF_MODERATOR_MODERATION = "set_chief_moderator_moderation";
export const SET_RECOMMENDATION_CUTOFF_LIST = "set_recommendation_cutoff_list";
export const GET_INTERVIEW_QUALIFIED_CANDIDATE = "get_interview_qualified_candidate";
export const SET_RECOMMENDATION_VIGATVARI_DATA = "set_recommendation_vigatvari_data";
export const SET_ADMITED_CANDIDATE_LIST = "set_admited_candidate_list";
export const SET_QUALIFIED_CANDIDATE_LIST = "set_qualified_candidate_list";
export const SET_INTERVIEWED_CANDIDATE_LIST = "set_interviewed_candidate_list";
export const SET_MERITORIOUS_CANDIDATE_LIST = "set_meritorious_candidate_list";
export const SET_PRESENT_CANDIDATE_LIST = "set_present_candidate_list";
export const SET_SUBJECT_CODE_ROLLNO = "set_subject_code_rollno";
export const SET_EXAM_CODE_ROLLNO = "set_exam_code_rollno";
export const SET_INTERVIEW_SCHEDULE = "set_interview_schedule";
export const SET_MAINS_ADVERTISEMENT = "set_mains_advertisement";
export const SET_PRE_ADVERTISEMENT = "set_pre_advertisement";
export const GET_INTERVIEW_CRITERIA_DATA_VIEW = "get_interview_criteria_data_view";
export const SET_USER_DEPT_ROLES = "set_user_dept_roles";
export const SET_USER_DEPT_ROLES_FROM = "set_user_dept_roles_from";
export const GET_RECOMMENDATION_CRITERIA_DATA_VIEW = "get_recommendation_criteria_data_view";
export const SET_OBJECTIVE_STATUS_DATA_FLAG = "set_objective_status_data_flag";
export const SET_REVISED_INTERVIEW_SCHEDULE = "set_revised_interview_schedule";
export const SET_INTERVIEW_LETTER = "set_interview_letter";
export const SET_MODULE_SUBMODULE = "set_module_submodule";
export const SET_UPDATE_USER_DATA_ID = "set_update_user_data_id";
export const SET_FILE_UPLOAD_STATUS = "set_file_upload_status";
export const SET_ANSWER_KEY_SET_LIST = "set_answer_key_set_list";
export const SAVE_RESULT_FLOW_REQUEST = "SAVE_RESULT_FLOW_REQUEST";
export const SAVE_RESULT_FLOW_SUCCESS = "SAVE_RESULT_FLOW_SUCCESS";
export const SAVE_RESULT_FLOW_FAILURE = "SAVE_RESULT_FLOW_FAILURE";
export const SET_POST_CRITERIA_LIST = "SET_POST_CRITERIA_LIST";
export const SET_SUBJECT_LIST_POST = "SET_SUBJECT_LIST";
export const SET_RESULT_FLOW_INFO="SET_RESULT_FLOW_INFO";
export const SET_LOOKUP_OPTIONS_EXAM_TYPE="SET_LOOKUP_OPTIONS_EXAM_TYPE";
export const SET_CHECK_QUALIFIED_LIST = "SET_CHECK_QUALIFIED_LIST";
export const SET_FINAL_RESULT_LIST = "SET_FINAL_RESULT_LIST";
export const SET_CUTOFF_SUMMARY = "SET_CUTOFF_SUMMARY";
export const SET_ADVERTISEMENT_RESULT_FLOW = "GET_ADVERTISEMENT_RESULT_FLOW";
export const SET_YEARS_FROM_EXAM_FLOW = "SET_YEARS_FROM_EXAM_FLOW";
export const SET_RESULT_FLOW_YEAR_LIST = "SET_RESULT_FLOW_YEAR_LIST";
export const SET_RESULT_FLOW_ADVERTISEMENT_LIST = "SET_RESULT_FLOW_ADVERTISEMENT_LIST";
export const SET_QUESTION_SET_LIST = "SET_QUESTION_SET_LIST";
export const SET_PROCESS_LOCK_STATE = "SET_PROCESS_LOCK_STATE";
export const GET_EXAM_NAME = "GET_EXAM_NAME";
export const GET_STAGE_LIST = "GET_STAGE_LIST";
export const GET_RECOMMENDATION_CRITERIA_VIEW =
  "GET_RECOMMENDATION_CRITERIA_VIEW";
export const GET_POST_CRITERIA_LIST = "GET_POST_CRITERIA_LIST";
export const GET_INTERVIEW_SCRUTINY_CANDIDATES =
  "GET_INTERVIEW_SCRUTINY_CANDIDATES";
export const SAVE_INTERVIEW_STATUS = "SAVE_INTERVIEW_STATUS";